import { createSelector, Selector } from 'reselect'
import { MetadataState } from '@/checkout-instore-legacy/metadata/reducer'
import { orderFormIdSelector } from '@/checkout-instore-legacy/order/selectors'

const metadataSelector: Selector<RootState, MetadataState> = (state) =>
  state.metadata

export const currentCartSelector = createSelector(
  [orderFormIdSelector, metadataSelector],
  (orderFormId, metadata) => metadata.carts[orderFormId]
)

export const shippingWasFilledSelector = createSelector(
  currentCartSelector,
  (cart) => cart?.shippingFilled || false
)
